export default "__VITE_ASSET__BzT5Pbku__"